import { createFileRoute } from '@tanstack/react-router';
import { useLogoutAll, useRevokeSession, useSessions } from '#features/auth/api';
import { Button } from '#components/ui/button';
import { formatDateTime } from '#lib/format-date';

const SessionsPage = () => {
  const sessions = useSessions();
  const revoke = useRevokeSession();
  const logoutAll = useLogoutAll();
  const others = (sessions.data ?? []).filter((s) => !s.current);

  return (
    <main className="mx-auto max-w-3xl p-6">
      <div className="flex items-center justify-between">
        <h1 className="text-xl">Active sessions</h1>
        <Button
          type="button"
          variant="secondary"
          size="sm"
          disabled={others.length === 0 || logoutAll.isPending}
          onClick={() => logoutAll.mutate()}
        >
          Sign out everywhere
        </Button>
      </div>
      <ul className="mt-4 divide-y divide-border">
        {(sessions.data ?? []).map((session) => (
          <li key={session.id} className="flex items-center justify-between py-3 text-sm">
            <div>
              <p className="font-medium">
                {session.userAgent ?? 'Unknown device'}
                {session.current ? ' · this session' : ''}
              </p>
              <p className="text-muted-foreground">
                {session.ip ?? 'IP unavailable'} · Last active {formatDateTime(session.lastSeenAt)}
              </p>
            </div>
            {session.current ? null : (
              <Button
                type="button"
                variant="link"
                size="inline"
                onClick={() => revoke.mutate(session.id)}
                aria-label={`Sign out of ${session.userAgent ?? 'unknown device'}`}
              >
                Sign out
              </Button>
            )}
          </li>
        ))}
      </ul>
    </main>
  );
};

export const Route = createFileRoute('/_authed/settings/sessions')({ component: SessionsPage });
